import React from 'react';
import TrackVisibility from "react-on-screen";
import Skill from "./Skill";

const progressData = [
    {
      id: 1,
      title: "Preparation with Expert Guidance",
      percantage: 90,
      progressColor: "#059DFF",
    },
    {
      id: 2,
      title: "Highest Pay on your Skill",
      percantage: 80,
      progressColor: "#059DFF",
    },
    {
      id: 3,
      title: "Get Offer Letter Gurantee",
      percantage: 95,
      progressColor: "#059DFF",
    },
];

const ProgressbarTwo = () => {
    return (
        <>
            {progressData.map((progress) => (
            <TrackVisibility
                once
                key={progress.id}
                className="single-progress"
            >
                <Skill progress={progress} /> 
            </TrackVisibility>
            ))} 
        </>
    )
}

export default ProgressbarTwo;
